/** Deve coincidir com a invalidacao da feature Copiloto (`["insights", "summary"]`). */
export const INSIGHT_SUMMARY_QUERY_KEY = ["insights", "summary"] as const;
